<template>
  <div>

  </div>
</template>

<script>
  import axios from 'axios';
  import { required, numeric } from 'vuelidate/lib/validators'; // Validators pre built into vuelidate - lecture 373
  import ProfileView from './profile/ProfileView'

  // https://www.npmjs.com/package/vue-loading-overlay
  import Vue from 'vue';
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  // Init plugin
  Vue.use(Loading);

  export default {
    props: ['userID'],
    data () {
      return {
        editing: false,

        user: {},
        // users: [],
        currentStep: 1,

        summary: '',
        profilePic: '',
        name: '',
        firstName: '',
        lastName: '',
        phone: '',
        city: '',
        provinceState: '',
        // cities: ['Bogotá', 'Medellin', 'Cali', 'Barranquilla', 'Cartagena', 'Cúcuta', 'Soledad', 'Ibagué', 'Soacha', 'Bucaramanga'],
        country: '',
        address1: '',
        address2: '',
        postalCode: '',

        organizationTypes: [],
        organizationTypesOptions: [],
        focusAreas: [],
        focusAreasOptions: [],
        skills: [],
        skillsOptions: [],
        // organizationStatures: [],
        // organizationStaturesOptions: [],
        sizes: [],
        sizesOptions: [],
        countries: [],
        countriesOptions: [],
        salaryRange: '',
        salaryRangeOptions: [],
        jobTypes: [],
        jobTypesOptions: [],

        pep: null,
        experiences: [],
        availability: [],
        title: '',
        reference: '',
        step1saveClicked: false,
        step2saveClicked: false,
        // --
        title: '',

        randomRenderer: [],

        resume: '',
      }
    },
    components: {
      appProfileView: ProfileView,
    },
    validations: { // Lecture 373
      // name: {
      //   required,
      // },
      firstName: {
        required,
      },
      lastName: {
        required,
      },
      // phone: {
      //   required,
      // },
      city: {
        required,
      },
      country: {
        required,
      },
      address1: {
        required,
      },
      postalCode: {
        required,
      }
      // address2: {
      //   required,
      // },
      // pep: {
      //   required,
      //   numeric,
      // },
    },
    computed: {
      auth () { // Lecture 363
        return this.$store.getters.isAuthenticated
      }
    },
    created () {
      if (!this.userID) { // Don't want to scroll the page up if viewing the profile via the admin dashboard
        // Scroll the window up
        window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
      }

      this.getUser()

      this.sizesOptions = this.$store.getters.organizationSizes
      this.organizationTypesOptions = this.$store.getters.organizationTypes
      this.focusAreasOptions = this.$store.getters.focusAreas
      this.countriesOptions = this.$store.getters.countries
      this.skillsOptions = this.$store.getters.skills
      this.salaryRangeOptions = this.$store.getters.salaryRanges
      this.jobTypesOptions = this.$store.getters.jobTypes
    },
    mounted() {
      document.title = this.$refs.pageTitle.innerHTML
    },
    methods: {
      getUser() {
        var userID = null
        if (this.userID) {
          userID = this.userID
        } else {
          userID = this.$store.getters.userID
        }
        // console.log(this.$store.getters.userID)

        // axios.get('/api/people/?id='.concat(this.$store.getters.userID))
        axios.get('/api/people/?id='+userID.toString())
          .then(res => {
            // console.log(res)
            this.user = res.data[0]

            this.summary = this.user.overview
            // this.name = this.user.name
            this.firstName = this.user.first_name
            this.lastName = this.user.last_name
            this.phone = this.user.phone
            this.city = this.user.city
            this.provinceState = this.user.provincestate
            this.country = this.user.country
            this.postalCode = this.user.postal_code
            this.address1 = this.user.address1
            this.address2 = this.user.address2

            this.skills = this.user.skills
            this.focusAreas = this.user.sectors
            this.jobTypes = this.user.job_types
            this.organizationTypes = this.user.preferences3
            this.countries = this.user.preferences2
            this.sizes = this.user.preferences

            this.salaryRange = this.user.salary_range

            // The idea here is the first time someone logs in, or if they haven't yet filled in step 1, they should immediately be in edit mode
            // if (!this.firstName) {
            //   this.editing = true
            // }
          })
          .catch(error => console.log(error))
      },
      // https://serversideup.net/uploading-files-vuejs-axios/
      handleFileUpload() {
        this.profilePic = this.$refs.profile_pic.files[0];
        this.resume = this.$refs.resume.files[0];
      },
      saveStep1() {
        console.log('Saving Step 1')
        // $v.name.$touch();
        this.$v.$touch()
        // this.step1saveClicked = true
        // console.log(this.$store.getters.userAPIURL)
        // axios.patch(this.$store.getters.userAPIURL, {name: this.name})
        //   .then(res => console.log(res))
        //   .catch(error => console.log(error))

        // Only write to the database if all the fields have been filled
        // pep needs to be filled and be a number - https://stackoverflow.com/questions/175739/built-in-way-in-javascript-to-check-if-a-string-is-a-valid-number
        // if (this.name && this.city && this.country && this.address1 && this.pep && !isNaN(this.pep)) {
        // if (!this.$v.firstName.$error && !this.$v.lastName.$error && !this.$v.address1.$error && !this.$v.city.$error && !this.$v.country.$error && !this.$v.postalCode.$error) {
        if (!this.$v.firstName.$error && !this.$v.lastName.$error) {

          console.log(this.user.status)
          let new_status = this.user.status
          if (this.user.status == '' || this.user.status == 'New') { // We only want to update the status if the user is at an earlier status
            new_status = 'Personal Information'
          }

          axios.patch('/api/people/'.concat(this.user.id.toString()).concat('/'),
            {
              // name: this.name,
              overview: this.summary,
              first_name: this.firstName,
              last_name: this.lastName,
              phone: this.phone,
              city: this.city,
              provincestate: this.provinceState,
              country: this.country,
              address1: this.address1,
              address2: this.address2,
              postal_code: this.postalCode,
              status: new_status,

              skills: this.skills,
              job_types: this.jobTypes,
              sectors: this.focusAreas,
              preferences: this.sizes,
              preferences2: this.countries,
              preferences3: this.organizationTypes,

              salary_range: this.salaryRange,
            }
          )
            .then(res => {
              console.log('Step 1 Saved')
              console.log(res)

              let formData = new FormData();
              if (this.profilePic) {
                formData.append('profile_pic', this.profilePic);
              }
              if (this.resume) {
                formData.append('resume', this.resume);
              }

              axios.patch( '/api/people/'.concat(this.user.id.toString()).concat('/'),
                formData,
                {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                }
              )
                .then(res => {
                  // Scroll the window back up after saving the step
                  window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route

                  this.getUser()
                  this.editing = false

                  // https://www.npmjs.com/package/vue-loading-overlay
                  let loader = this.$loading.show({
                    // Optional parameters
                    container: this.fullPage ? null : this.$refs.formContainer,
                    // container: this.$refs.formContainer,
                    // canCancel: true,
                    canCancel: false,
                    // onCancel: this.onCancel,
                  });
                  // simulate AJAX
                  setTimeout(() => {
                    loader.hide()
                  },2000)
                })
                .catch(error => {
                  console.log(error)
                })

            })
            .catch(error => console.log(error))
        }
      },
    },
  }
</script>

<style>

  /* PROFILE FORM TOP STEPS */
  .profile-step {
    border-bottom: 3px solid var(--thrivehiregrey);
  }
  .profile-step:hover {
    cursor: pointer;
  }
  .profile-step h4 {
    color: var(--thrivehiregrey);
  }
  .profile-step small {
    font-weight: 600;
    text-transform: uppercase;
    color: var(--thrivehiregrey);
  }
  .active-step {
    border-bottom: 3px solid var(--coredarkcolor);
  }
  .active-step h4 {
    color: var(--coredarkcolor);
  }
  .inactive-step {
    border-bottom: 3px solid var(--thrivehiregrey);
  }
  .inactive-step h4 {
    color: var(--thrivehiregrey);
  }
  .inactive-step small {
    font-weight: 600;
    text-transform: uppercase;
    color: var(--thrivehiregrey);
  }
  .active-step small {
    font-weight: 600;
    text-transform: uppercase;
    color: gray;
  }
  /* ------ */

  /* Lecture 299 */
  .slide-enter-active {
    animation: slide-in 300ms ease-out forwards;
  }

  .slide-leave-active {
    animation: slide-out 300ms ease-out forwards;
  }

  @keyframes slide-in {
    from {
      transform: translateY(-30px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @keyframes slide-out {
    from {
      transform: translateY(0px);
      opacity: 1;
    }
    to {
      transform: translateY(-30px);
      opacity: 0;
    }
  }

  /* Classes that get attached to form fields that fail vuelidation */
  .invalid label {
    color: red;
  }
  .invalid small {
    color: red;
  }

</style>



// WEBPACK FOOTER //
// src/components/candidates/CandidateProfile.vue